import { Stack } from "@mui/material";
import { EliceButton } from "../../button";

export interface LayoutFooterSubmitProps {
  isRollback?: boolean;
  isSubmit?: boolean;
  disableRollback?: boolean;
  disableSubmit?: boolean;
  submitText?: string;
  rollbackText?: string;
  onRollback?: () => void;
  onSubmit?: () => void;
  submitButtonColor?: string;
  rollbackButtonColor?: string;
  submitTextColor?: string;
  rollbackTextColor?: string;
}

const LayoutFooterSubmit = ({
  isRollback = false,
  isSubmit = false,
  disableRollback = false,
  disableSubmit = false,
  submitText,
  rollbackText,
  onSubmit,
  onRollback,
  submitButtonColor,
  rollbackButtonColor,
  submitTextColor = '#fff',
  rollbackTextColor,
}: LayoutFooterSubmitProps) => {
  return (
    <Stack direction="row" spacing={1}>
      {isRollback && (
        <EliceButton
          disabled={disableRollback}
          variant="outlined"
          size="medium"
          customColor={rollbackButtonColor}
          textColor={rollbackTextColor}
          onClick={onRollback}
        >
          {rollbackText ?? "다시하기"}
        </EliceButton>
      )}
      {isSubmit && (
        <EliceButton
          disabled={disableSubmit}
          variant="contained"
          size="medium"
          customColor={submitButtonColor}
          textColor={submitTextColor}
          onClick={onSubmit}
        >
          {submitText ?? "제출하기"}
        </EliceButton>
      )}
    </Stack>
  );
};

export default LayoutFooterSubmit;
